import { lazy } from 'react'

export const DeleteClientCommentModalAsync = lazy(() =>
    import('./DeleteClientCommentModal').then((module) => ({
        default: module.DeleteClientCommentModal,
    }))
)
